module.exports = __webpack_public_path__ + "static/media/objects2_13.6eac80ec.svg";